import { createStyles, Theme } from '@material-ui/core/styles'

export default (theme: Theme) =>
	createStyles({
		activeContainer: {
			padding: theme.spacing(2),
			display: 'flex',
			flexDirection: 'row',
			alignItems: 'flex-start',
			justifyContent: 'space-between',
			flexGrow: 1,
			alignSelf: 'stretch',
			overflow: 'hidden',
			// background: '#fff',
			zIndex: 101,
			borderRadius: '10px 10px 0 0',
			'& > div:not(:first-child):last-child:not($root)': {
				marginBottom: 'auto',
				padding: `${theme.spacing(2)}px 0px`,
			},
			// [theme.breakpoints.down('sm')]: {
			// 	position: 'fixed',
			// 	top: 0,
			// 	left: 0,
			// 	right: 0,
			// 	bottom: 0,
			// 	background: '#ffffff',
			// 	paddingRight: theme.spacing(2),
			// 	paddingLeft: theme.spacing(2),
			// 	zIndex: 100,
			// },
		},
		cssUnderline: {
			'&:before': {
				borderBottomColor: theme.palette.grey[200],
			},
			'&&&&:hover:before': {
				borderBottom: `1px solid ${theme.palette.primary.main}`,
			},
			'&:after': {
				borderBottomColor: theme.palette.secondary.main,
			},
		},
		iconRoot: {
			marginRight: theme.spacing(1),
			[theme.breakpoints.down('sm')]: {
				marginRight: 0,
			},
		},
		doneButton: {
			alignSelf: 'center',
			borderRadius: 18,
			color: theme.palette.grey[500],
			borderColor: theme.palette.grey[500],
		},
		searchHeader: {
			display: 'flex',
			flexDirection: 'row',
			flex: 1,
		},
		tabsContent: {
			flex: 1,
			alignSelf: 'stretch',
			boxShadow: 'none',
			background: 'transparent',
		},
		padding: {
			padding: `0 ${theme.spacing(2)}px`,
		},
		root: {
			maxHeight: '100%',
			padding: '2px 4px',
			display: 'flex',
			alignItems: 'flex-start',
			alignSelf: 'stretch',
			borderRadius: 10,
			flexDirection: 'column',
			zIndex: 101,
			'& > div:first-child': {
				display: 'flex',
				// flexGrow: 1,
				alignSelf: 'stretch',
			},
			'& > div:not(:first-child)': {
				overflow: 'auto',
				flex: 1,
			},
			'& .rcs-custom-scroll .rcs-inner-handle': {
				marginTop: '6px',
				backgroundColor: `${theme.palette.secondary.light} !important`,
				borderRadius: '3px',
			},
		},
		input: {
			// marginLeft: 12,
			marginTop: 12,
			marginBottom: 12,
			flex: 1,
			alignSelf: 'flex-start',
		},
		iconButton: {
			padding: 10,
			color: theme.palette.grey[500],
		},
		chip: {
			margin: 2,
		},
		chipActive: {
			margin: 2,
			borderColor: theme.palette.primary.main,
			color: theme.palette.primary.main,
			cursor: 'pointer',
		},
		chipInactive: {
			margin: 2,
			borderColor: '#ebebeb',
			color: '#c9c9c9',
		},
		notFound: {
			alignSelf: 'stretch',
			padding: 15,
			textAlign: 'center',
			fontStyle: 'italic',
			color: '#c9c9c9',
		},
	})
